<div class="tooltip-wrapper" [style]="'border-left: 0.375rem solid ' + borderLeftColour + ';'">
    <div class="value-wrapper">
        <span class="valuestyle">{{xValue}}</span>
    </div>
    <div class="value-wrapper">
        <span class="valuestyle">{{yValue}}</span>
    </div>
</div>

